import axios from "axios";

import { CONSTANTS } from "services";
import { DataEntity } from "./shared";

const resource = "content/public/translations";

/**
 * Get translations by certain language
 *
 * @method getTranslationsByLang
 * @param {String} language
 * @returns {Function}
 */
export const getTranslationsByLangContent = async (language) => {
  try {
    const result = await axios.get(
      `${CONSTANTS.serviceDomain}/${resource}?language=${language}`
    );
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};
class Translations {
  constructor() {
    this.translations = null;
  }

  async fetchTranslations({ lang }) {
    try {
      const result = await getTranslationsByLangContent(lang);
      if (result.data.translations) {
        return result;
      }
      return null;
    } catch (err) {
      // TODO handle error on prod
      // Integrate with error logging provider
      console.error("get translations", err);
    }
  }

  static async initialize({ lang }) {
    const response = await new Translations().fetchTranslations({ lang });
    return new DataEntity(response);
  }
}

export default Translations;
